import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.create`;

export const INIT = `${SCOPE}/INIT`;
export const CREATE_DASHBOARD = `${SCOPE}/CREATE_DASHBOARD`;
export const CREATE_DASHBOARD_BY_DASHBOARD_TYPE = `${SCOPE}/CREATE_DASHBOARD_BY_DASHBOARD_TYPE`;
